import React, { useContext, useEffect } from "react";
import "../components/style_v2.css"
import "../components/style.css";
import 'lightbox2/dist/css/lightbox.min.css';
import 'lightbox2/dist/js/lightbox.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import DevSection from "../components/product_lib/DevSection";
import MasLibIntro from "../components/product_lib/MasLibIntro";
import ReportOverview from "../components/product_lib/ReportOverview";
import DownloadSection from "../components/product_lib/DownloadSection";
import { LanguageContext } from "../context/LanguageContext";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("DevSection", "product_lib/product_lib_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.DevSection || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <Topbar />
      <Navbar />
      <Carousel />
      <DevSection />
      <MasLibIntro />
      <ReportOverview />
      <DownloadSection />
    </div>
  );
};

export default Page;